/* Sizing: sticky add-to-cart + size chart popup. Safe to remove by deleting the si-* files. */
(function () {
  'use strict';

  /* ---------- Sticky add to cart ---------- */
  function money(cents) {
    try {
      if (window.theme && window.theme.Currency && window.theme.Currency.formatMoney) {
        return window.theme.Currency.formatMoney(cents, (window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}');
      }
    } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }

  function shortSize(t) {
    var base = String(t).split(' (')[0].split(/ pre-?order/i)[0].trim();
    var v = base.toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ');
    var map = { 'xx small': 'XXS', 'xxs': 'XXS', 'x small': 'XS', 'extra small': 'XS', 'xs': 'XS', 'small': 'S', 's': 'S', 'medium': 'M', 'm': 'M',
      'large': 'L', 'l': 'L', 'x large': 'XL', 'extra large': 'XL', 'xl': 'XL', 'xx large': 'XXL', '2x large': 'XXL', '2xl': 'XXL', 'xxl': 'XXL',
      'xx large / 2xl': 'XXL', 'xxx large': '3XL', '3xl': '3XL', 'small/medium': 'S/M', 'large/x large': 'L/XL', 'large/xl': 'L/XL',
      'youth x small': 'YXS', 'youth small': 'YS', 'youth medium': 'YM', 'youth large': 'YL', 'youth x large': 'YXL' };
    return map[v] || base;
  }

  function initSticky(bar) {
    var section = document.getElementById('ProductSection-' + bar.dataset.sectionId + '-' + bar.dataset.productId);
    if (!section) return;
    var form = section.querySelector('.product-single__form');
    var addBtn = form ? form.querySelector('[data-add-to-cart]') : null;
    var sizesWrap = bar.querySelector('[data-si-sticky-sizes]');
    var priceEl = bar.querySelector('[data-si-sticky-price]');
    var btn = bar.querySelector('[data-si-sticky-btn]');
    if (!form || !addBtn || !btn) return;

    var sizeFieldset = section.querySelector('.variant-input-wrap[data-handle="size"]');
    if (sizeFieldset) {
      sizeFieldset.querySelectorAll('.variant-input').forEach(function (wrap) {
        var input = wrap.querySelector('input[data-variant-input]');
        var label = wrap.querySelector('.variant__button-label');
        if (!input || !label) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'si-sticky-atc__size' + (input.checked ? ' is-active' : '') + (input.classList.contains('disabled') ? ' is-disabled' : '');
        var full = (label.getAttribute('data-si-full') || input.value || label.textContent).trim();
        b.textContent = shortSize(full);
        b.title = full;
        if (/pre-?order/i.test(full)) b.className += ' is-preorder';
        b.addEventListener('click', function () {
          if (input.checked) return;
          input.click();
        });
        input.addEventListener('change', function () { b.classList.toggle('is-active', input.checked); });
        sizesWrap.appendChild(b);
      });
    }

    function readTier() {
      var tier = section.querySelector('.custom-quantity-selector input[name="quantity_tier"]:checked')
        || document.querySelector('.custom-quantity-selector input[name="quantity_tier"]:checked');
      if (!tier) return null;
      var cents = parseInt(tier.getAttribute('data-discounted-price-cents'), 10);
      var qty = parseInt(tier.value, 10) || 1;
      return isNaN(cents) ? null : { cents: cents, qty: qty };
    }

    function sync() {
      var v = null;
      try {
        var variants = JSON.parse(section.querySelector('[data-variant-json]').textContent);
        var sel = form.querySelector('[data-product-select]');
        if (sel && sel.value) v = variants.find(function (x) { return String(x.id) === String(sel.value); });
      } catch (e) {}
      var tier = readTier();
      if (priceEl) {
        if (tier && tier.qty > 1) priceEl.textContent = money(tier.cents) + ' for ' + tier.qty;
        else if (v) priceEl.textContent = money(v.price);
        else if (tier) priceEl.textContent = money(tier.cents);
      }
      var available = v ? v.available : !addBtn.disabled;
      btn.disabled = !available;
      btn.textContent = available ? addBtn.querySelector('[data-add-to-cart-text]').textContent.trim() : 'Sold out';
      if (sizeFieldset) {
        var chips = sizesWrap.children;
        sizeFieldset.querySelectorAll('input[data-variant-input]').forEach(function (input, i) {
          if (!chips[i]) return;
          chips[i].classList.toggle('is-active', input.checked);
          chips[i].classList.toggle('is-disabled', input.classList.contains('disabled'));
        });
      }
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      addBtn.click();
    });

    var observer = new MutationObserver(sync);
    observer.observe(addBtn, { attributes: true, childList: true, subtree: true });
    document.addEventListener('variant:change', function () { setTimeout(sync, 40); });
    document.querySelectorAll('.custom-quantity-selector input[name="quantity_tier"]').forEach(function (r) {
      r.addEventListener('change', function () { setTimeout(sync, 40); });
    });
    sync();

    // Show the bar once the real Add to Cart button has scrolled above the viewport.
    var ticking = false;
    function update() {
      ticking = false;
      var r = addBtn.getBoundingClientRect();
      var show = r.bottom < 0 || (r.width === 0 && r.height === 0 && window.scrollY > 600);
      if (show !== bar.classList.contains('is-visible')) {
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      document.documentElement.style.setProperty('--si-sticky-h', (show ? bar.offsetHeight : 0) + 'px');
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- Product's own size chart in a popup ---------- */
  function initSizeChart() {
    var dialog = document.querySelector('[data-si-size-chart]');
    if (!dialog) return;
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest('a[href*="/pages/size-chart"], [data-si-open-size-chart], tool-tip-trigger[data-tool-tip="size-chart"]');
      if (!a || a.hasAttribute('data-si-no-intercept') || dialog.contains(a)) return;
      if (typeof dialog.showModal !== 'function') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      dialog.showModal();
    }, true);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-si-modal-close]')) dialog.close();
    });
  }

  function boot() {
    document.querySelectorAll('[data-si-sticky]').forEach(initSticky);
    initSizeChart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
